import cn from 'comma-number'
import { isClientSide } from './index'

export const getRoundCommaNum = (value) => {
  if(!value || value === 'NaN') return '0'
  return cn(Math.round(value))
}

const phoneFormatRegex = /^(?:\+?1[-. ]?)?(?:\(?([0-9]{3})\)?[-. ]?)?([0-9]{3})[-. ]?([0-9]{4})$/

/**
 * @param phoneNum
 * @param withNational - show +1 (999) else 999
 * @param withDash - show 999-9999 else 999 9999
 * @returns {*}
 */
export const formatPhoneNumber = (phoneNum) => {
  const regexObj = phoneFormatRegex
  if(regexObj.test(phoneNum)) {
    const parts = phoneNum.match(regexObj)
    let phone = ''
    if(parts[1]) {
      phone += `${parts[1]}-`
    }
    phone += `${parts[2]}-${parts[3]}`
    return phone
  }

  // invalid phone number
  return phoneNum
}


/* eslint-disable */
export const reportValidity = (form) => {
  if(isClientSide()) {
    if(!HTMLFormElement.prototype.reportValidity) {
      HTMLFormElement.prototype.reportValidity = function () {
        if(this.checkValidity()) return true
        var btn = document.createElement('button')
        this.appendChild(btn)
        btn.click()
        this.removeChild(btn)
        return false
      }
    } else {
      return form.reportValidity()
    }
  }
}
export const formatPrice = (price) => (
  price
    ? '$' + cn(parseFloat(price))
    : price
)

/* eslint-enable */
